<template>
    <div class="DynamicCard">
        <template v-if="isLoading">
            <template v-for="index in placeholderCount">
                <div
                    :key="index"
                    class="DynamicCard__card DynamicCard__card--loading"
                >
                </div>
            </template>
        </template>
        <template v-else>
            <template v-for="row in cardsData">
                <slot
                    :row="row"
                    name="row"
                >
                    <div
                        :key="JSON.stringify(row)"
                        :class="cardClass(row)"
                    >
                        <slot :card="row"></slot>
                    </div>
                </slot>
            </template>
            <template v-if="cardsData.length < 1 && showEmptyCard">
                <slot name="emptyCard"></slot>
            </template>
        </template>
    </div>
</template>
<script>
import stat from 'status';
import statusBuilder from 'status/statusBuilder';
import has from 'lodash/has';

export default {
    name: 'RPDynamicCard',
    props: {
        cardsData: {
            type: Array,
            default: () => ([])
        },
        showEmptyCard: {
            type: Boolean,
            default: false,
        },
        placeholderCount: {
            type: Number,
            default: 5,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    computed: {
        isLoading() {
            return this.status === stat.LOADING;
        },
    },
    methods: {
        cardClass(card) {
            return has(card, 'status')
                ? statusBuilder('DynamicCard__card', card.status)
                : 'DynamicCard__card';
        },
    },
};
</script>
<style lang="scss">
    .DynamicCard {
        display: grid;
        margin-bottom: 1rem;
        &__card {
            margin-bottom: 1rem;
            padding: 1rem;
            background: $white;
            border-radius: 4px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
            border: 1px solid transparent;
            @include loading(4rem, 100%);

            &--saving {
                border: 1px solid $secondary-purple-300;
            }
            &--success {
                border: 1px solid $success-green;
            }
            &--error {
                border: 1px solid $error-red;
            }
            &--warning {
                border: 1px solid $warning-yellow;
            }
        }
    }
</style>

<docs>
The Dynamic Card component is intended to display a variable length list of cards.

```[import](./RPDynamicCardExample.vue)
```
</docs>
